export default __webpack_public_path__ + "static/media/items_ojk01.8d172da5.jpg";